import { render } from "./GenerateLink.vue?vue&type=template&id=a96bd79a&scoped=true&bindings={\"status\":\"data\",\"miracle\":\"data\",\"content\":\"data\",\"copy\":\"options\",\"save\":\"options\",\"encoded\":\"options\"}"
import script from "./GenerateLink.vue?vue&type=script&lang=js"
export * from "./GenerateLink.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a96bd79a"

export default script